import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Possibilities = ({
    input,
    possibilities,
    setPossibilities,
    scrollTop,
    choosePossibility,
    selectedChoice,
    doc
}) => { 
    let [position, setPosition] = useState(undefined);
    useEffect(() => {
        if (input.current) {
            setPosition(getCursorXY(input.current, input.current.selectionStart));
        }
    }, [possibilities]);
    let style = {};
    if (position) {
        style.top = position.y + 16 - scrollTop;
        style.left = position.x;
        style.maxHeight = input.current.offsetHeight - style.top;
    }

    if (possibilities.length === 0) {
        return [];
    }
    return (
        <div
          style={style}
          className="possibilities">
          {possibilities.map(
              (x, i) =>
                  <div
                    key={i}
                    onMouseUp={(e) => {
                        e.stopPropagation();
                        choosePossibility(x);
                    }}
                    onMouseDown={(e) => {
                        e.stopPropagation();
                    }}
                    className={x === selectedChoice ? "selected option" : "option"}>
                    <div className="args">
                    <div className="keyword">{x}</div>
                    <div className="param">
                      (
                      {Object.keys(doc(x).params).join(', ')}
                      )
                    </div>
                    </div>
                    <div className="description">
                      {doc(x).description}
                    </div>
                  </div>)}
        </div>);
}

const getCursorXY = (input, selectionPoint) => {
  const {
    offsetLeft: inputX,
    offsetTop: inputY,
  } = input
  // create a dummy element that will be a clone of our input
  const div = document.createElement('div')
  // get the computed style of the input and clone it onto the dummy element
  const copyStyle = getComputedStyle(input)
  for (const prop of copyStyle) {
    div.style[prop] = copyStyle[prop]
  }
  // we need a character that will replace whitespace when filling our dummy element if it's a single line <input/>
  const swap = '.'
  const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value
  // set the div content to that of the textarea up until selection
  const textContent = inputValue.substr(0, selectionPoint)
  // set the text content of the dummy element div
  div.textContent = textContent
  if (input.tagName === 'TEXTAREA') div.style.height = 'auto'
  // if a single line input then the div needs to be single line and not break out like a text area
  if (input.tagName === 'INPUT') div.style.width = 'auto'
  // create a marker element to obtain caret position
  const span = document.createElement('span')
  // give the span the textContent of remaining content so that the recreated dummy element is as close as possible
  span.textContent = inputValue.substr(selectionPoint) || '.'
  // append the span marker to the div
  div.appendChild(span)
  // append the dummy element to the body
  document.body.appendChild(div)
  // get the marker position, this is the caret position top and left relative to the input
  const { offsetLeft: spanX, offsetTop: spanY } = span
  // lastly, remove that dummy element
  // NOTE:: can comment this out for debugging purposes if you want to see where that span is rendered
  document.body.removeChild(div)
  // return an object with the x and y of the caret. account for input positioning so that you don't need to wrap the input
  return {
    x: inputX + spanX,
    y: inputY + spanY,
  }
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Possibilities);
